module.exports = __webpack_public_path__ + "static/img/2025_phase_function_Paper_PointsHejduk_Prediction.195e210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2025_phase_function_Paper_PointsHejduk_Prediction.png
// module id = u26V
// module chunks = 0